// extracted by mini-css-extract-plugin
export var arrows = "_6c-5";
export var decrementer = "_6c-9";
export var disabled = "_6c-3";
export var error = "_6c-1";
export var hiddenText = "_6c-a";
export var incrementer = "_6c-8";
export var input = "_6c-7";
export var inputWrapper = "_6c-0";
export var leadingIcon = "_6c-b";
export var readonly = "_6c-2";
export var regular = "_6c-6";
export var small = "_6c-4";